/**
 * Created by chenqifeng on 2016/9/1.
 */
import {
	request
}             from '../http';
import domain from '../domain';

let WeixinService = function(){
        if( domain.env === 'online' ){
            this.domain = '//wechat.51tiangou.com';
        }
        else{
            this.domain = '//wechat.' + domain.env + '.66buy.com.cn';
        }
    }
    ;

/**
 * 网页获取openId
 * @param params
 * @deprecated
 */
WeixinService.prototype.login = function(params){
	let that = this
        ;

	params.tgError = params.tgError || function(){};

	if( params.data.openid && params.data.openid_cypher ){
		that._serviceAjaxCom('/publics/bind/login', params);
	}
	else{
		params.tgError();
	}
};

WeixinService.prototype.getOpenid = function(params = {}){
	let that = this
        ;

	params.type = 'GET';
	params.tgError = params.tgError || function(){};

	if( params && params.data && params.data.code ){
		that._serviceAjaxCom('/publics/wechat/getOpenid', params);
	}
	else{
		params.tgError();
	}
};

WeixinService.prototype.sign = function(params){
	let that = this
        ;

	params.tgError = params.tgError || function(){};
	params.type = 'GET';

	that._serviceAjaxCom('/publics/wechat/sign', params);
};

WeixinService.prototype.getImageUrlByServerId = function(params){
	let that = this
        ;

	params.type = 'POST';

	that._serviceAjaxCom('/publics/wechat/getTempFile', params);
};

/**
 * 调试接口用假函数
 * @param params
 */
WeixinService.prototype.getImageUrlByServerIdDebug = function(params){
	params.success('wexin/jsadkldjhsakldjlsajdsaljjjksladjlsa');
};

WeixinService.prototype._serviceAjaxCom = function(url, params){
	params.url = this.domain + url;

	return request( params );
};

/**
 * 给好友投票
 * @param params
 */
WeixinService.prototype.getInfoByCode = function(params){
	let that = this
        ;

	if( params.data.code && params.data.appid ){
		that._serviceAjaxCom('/publics/wechat/getUserInfoByAppId', params);
	}
	else{
		params.tgError({
			success: false
            , code: 502
            , message: '参数缺失'
		});
	}
};

/**
 * 给好友投票
 * @param params
 */
WeixinService.prototype.getUserInfoByAccessToken = function(params){
	let that = this
        ;

	that._serviceAjaxCom('/publics/wechat/getUserInfoByAccessToken', params);
};

/**
 * 免费试用活动核销
 * @param params
 */
WeixinService.prototype.trialVerify = function(params){
	let that = this
        ;

	that._serviceAjaxCom('/publics/activity/trial/verify', params);
};

/**
 * 申请免费试用
 * @param params
 */
WeixinService.prototype.trialApply = function(params){
	let that = this;

	that._serviceAjaxCom('/publics/activity/trial/apply', params);
};

/**
 * 礼品卡 Code 解码
 * @param params
 */
WeixinService.prototype.giftCardDecrypt = function(params){
	let that = this
        ;

	that._serviceAjaxCom('/publics/wechat/giftCard/code/decrypt', params);
};

/**********************************************************
 *                      微信绑定相关
 ***********************************************************/
/**
 * @deprecated
 * 2021-06-29
 * #50115   去掉 bind 相关业务逻辑
 * */
WeixinService.prototype.unionBind = function(params){
	this._serviceAjaxCom('/publics/wechat/union/bind', params);
};

/**
 * 微信联合登录【已登录】会员快速绑定
 * @param params
 * @deprecated
 * 2021-06-29
 * #50115   去掉 bind 相关业务逻辑
 */
WeixinService.prototype.quickBind = function(params){
	let that = this
        , _params = params || {}
        ;

	_params.type = 'POST';

	that._serviceAjaxCom('/publics/wechat/union/quickBind', _params);
};

WeixinService.prototype.webcastEntry = function(params){
	return this._serviceAjaxCom('/applet/broadcast/entry', params);
};

export default new WeixinService();